export const DEFAULT_DATE_FORMAT = "dd MMM yy";
export const DEFAULT_DATE_TIME_FORMAT = "dd MMM yy, hh:mm a";
export const DEFAULT_DATE_FORMAT_TZ = "dd MMM yy XXX";
export const DEFAULT_DATE_TIME_FORMAT_TZ = "dd MMM yy, hh:mm a XXX";
export const DEFAULT_TIME_FORMAT_TZ = "hh:mm aa XXX";
export const DEFAULT_MONTH_FORMAT = "MMM yyyy";
